import { render, staticRenderFns } from "./WAP.vue?vue&type=template&id=69481541&"
import script from "./WAP.vue?vue&type=script&lang=js&"
export * from "./WAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports